import axios from "axios";

// API base URL. Override per environment with REACT_APP_API_URL (set in the
// host dashboard / .env), e.g. a staging backend on Render. Falls back to the
// live production API so existing builds keep working with no config.
export const API_URL = (
  process.env.REACT_APP_API_URL || "https://ductsizerpro.com/api"
).replace(/\/+$/, "");

export const createUser = async (data) => {
  return await axios.post(`${API_URL}/user/signup`, data);
};

export const getUser = async () => {
  return axios.get(`${API_URL}/user/get-All`);
};

export const updateUser = async () => {
  return await axios.post(`${API_URL}/user/Update-user`);
};
export const LoginUser = async (data) => {
  return axios.post(`${API_URL}/user/login`, data);
};
export const contactUser = async (data) => {
  return axios.post(`${API_URL}/user/contact/create-or-update`, data);
};

// export const  = async ()=>{
//     return axios.post(`${API_URL}/user/login`)
// }
